import React, { Component } from 'react';

import * as landlordApplications from 'actions/landlordApplicationsActions';
import { getLandlordTrafficSources } from 'actions/landlordLeadsActions';
import * as landlordProperties from 'actions/landlordPropertiesActions';

import { connect } from 'react-redux';
import { destroy, submit } from 'redux-form';

import InviteLead from './InviteLead';

export default connect(
  store => {
    return {
      showPage: store.authentication.showPage,
      leaseDetails: store.leaseDetails.leaseDetails,
      properties: store.landlordProperties.properties,
      units: store.landlordProperties.units,
      unit: store.landlordProperties.unit,
      currentLeasesOfUnit: store.landlordProperties.currentLeasesOfUnit,
      trafficSources: store.landlordLeads.trafficSources,
    };
  },
  {
    ...landlordProperties,
    ...landlordApplications,
    getLandlordTrafficSources,
    destroy,
    submit,
  }
)(
  class InviteLeadDialog extends Component {
    componentDidMount = () => {
      this.props.getProperties({ for_multiselect: true, show_cities: true });
      this.props.getLandlordTrafficSources();
    };

    getLeasesAndMarketRent = unitId => {
      return this.props.getCurrentLeasesOfUnit(unitId).then(response => {
        return this.props.getUnit(unitId);
      });
    };

    render() {
      return (
        <InviteLead
          handleSubmit={this.props.submitForm}
          handleClose={this.props.toggleInviteLeadDialog}
          properties={this.props.properties}
          units={this.props.units}
          unitMarketRent={this.props.unit.market_rent}
          unitAbsoluteRent={this.props.unit.absolute_rent}
          unitMarketRentSixMonths={this.props.unit.absolute_rent_six_months}
          unitDepositAmount={this.props.unit.deposit_amount}
          getUnitDetails={this.props.getUnit}
          currentLeasesOfUnit={this.props.currentLeasesOfUnit}
          getUnits={this.props.getUnits}
          clearUnits={this.props.clearUnits}
          getCurrentLeasesOfUnit={unitId => this.getLeasesAndMarketRent(unitId)}
          trafficSources={this.props.trafficSources}
          showInviteLeadDialog={this.props.showInviteLeadDialog}
          clearCurrentLeasesOfUnit={this.props.clearCurrentLeasesOfUnit}
          submit={this.props.submit}
          transferApplication={this.props.transferApplication}
          leaseDetails={this.props.leaseDetails}
          disableLeaseWizardSelections={this.props.disableLeaseWizardSelections}
          onlyYardiBasedProperties={this.props.onlyYardiBasedProperties}
        />
      );
    }
  }
);
